import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/cleaning",
    clipPath: "url(#clip_Cleaning)"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6066 6.89939L15.9405 1.56548L14.5263 0.151269L9.19236 5.48517L6.36395 2.65676L4.94973 4.07097L12.0208 11.142L13.435 9.72783L10.6066 6.89939ZM8.49994 15.9999L10.3118 11.4368L4.65497 5.77997L0.0146544 7.51464L8.49994 15.9999Z",
    fill: "currentColor"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0"
  }, React.createElement("rect", {
    width: "16",
    height: "16",
    fill: "white"
  }))));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Cleaning16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Cleaning16 = createIcon(IconComponent);